<template>
  <div class="body">
    <div class="login_box">
      <!-- <div class="left_box">
        <img src="../assets/images/loginlog.png">
        <div class="explain">
          Copyright © 2023-2024 juliangkeji All Rights Reserved.
        </div>
      </div> -->
      <div class="right_box">
        <div class="right_box_item">
          <div class="login_title">
            <p>繁星智投用户端</p>
            <!-- <p style="font-size: 16px; font-weight: normal;">(不忘初心、砥砺前行)</p> -->
          </div>
          <div class="login_con">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="username" label-width="0">
                <el-input v-model="ruleForm.username" type="text" placeholder="账号" clearable prefix-icon="el-icon-user-solid">
                </el-input>
              </el-form-item>
              <el-form-item prop="password" label-width="0">
                <el-input v-model="ruleForm.password" type="password" placeholder="密码" show-password prefix-icon="el-icon-lock">
                </el-input>
              </el-form-item>
              <el-form-item prop="confirmPassword" label-width="0" v-if="registerType">
                <el-input v-model="ruleForm.confirmPassword" placeholder="确认密码" show-password prefix-icon="el-icon-lock">
                </el-input>
              </el-form-item>
              <div class="verification_box">
                <el-form-item prop="code" label-width="0">
                  <el-input v-model="ruleForm.code" placeholder="验证码" clearable
                    prefix-icon="el-icon-circle-check"></el-input>
                </el-form-item>
                <div class="login-code">
                  <img :src="codeUrl" @click="getCode" class="login-code-img" />
                </div>
              </div>
              <el-checkbox v-model="ruleForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
              <el-form-item size="large" label-width="0">
                <el-button type="primary"
                           :loading="loading"
                           @click.native.prevent="handleLogin"
                           v-if="!registerType"
                           style="width: 40%"
                >登  陆</el-button>
                <el-button type="warning" @click="goRegister">还没账号快速注册</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

      </div>
    </div>
    <div class="el-login-footer">
      <span><span @click="open" class="openSidebar">豫ICP备2024081589号</span>Copyright © 2023-2024 juliangfanxing.cn All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
  import { getCodeImg, login } from "../api/login";
  import { setToken, removeToken } from "../util/auth";
  import Cookies from "js-cookie";
  import { encrypt, decrypt } from "../util/jsencrypt";
  import { getInfo } from "../api/user"
  export default {
    data() {
      return {
        codeUrl: "",
        loading: false,
        registerType:false, // 是否为注册
        redirect: undefined,
        ruleForm: {
          username: '', // 账号
          password: '', // 密码
          confirmPassword:'', //确认密码
          code: '', // 验证码
          rememberMe: true,
        },
        queryuid:'',
        rules: {
          username: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
          confirmPassword: [{
            required: true,
            message: '请确认密码',
            trigger: 'blur'
          }],
          code: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }]
        },
      }
    },
    watch: {
      $route: {
        handler: function(route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    created() {
      this.getCode();
      this.getCookie();
      if(this.$route.query.uid){
        this.queryuid = this.$route.query.uid
        console.log("获取到的参数",this.queryuid)
      }
    },
    methods: {
      open(){
        window.open('https://beian.miit.gov.cn/')
      },
      getCode() {
        getCodeImg().then((res) => {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.ruleForm.uuid = res.uuid;
        });
      },
      getCookie() {
        const username = Cookies.get("username");
        const password = Cookies.get("password");
        const rememberMe = Cookies.get("rememberMe");
        this.ruleForm = {
          username: username === undefined ? this.ruleForm.username : username,
          password: password === undefined ? this.ruleForm.password : decrypt(password),
          rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        };
      },
      handleLogin() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.ruleForm.rememberMe) {
              Cookies.set("username", this.ruleForm.username, { expires: 30 });
              Cookies.set("password", encrypt(this.ruleForm.password), { expires: 30 });
              Cookies.set("rememberMe", this.ruleForm.rememberMe, { expires: 30 });
            } else {
              Cookies.remove("username");
              Cookies.remove("password");
              Cookies.remove("rememberMe");
            }
            login(this.ruleForm).then((res) => {
                if (200 == res.code) {
                  if (setToken(res.token)) {
                    this.$router.replace({ path: "/index" });
                    Cookies.set("thisusername", this.ruleForm.username, { expires: 30 });
                    // Cookies.set("accountLevel", this.ruleForm.username, { expires: 30 });
                  } else {
                    removeToken();
                    Cookies.remove("thisusername");
                    window.href = "/";
                  }

                  getInfo().then((response) => {
                    Cookies.set("userlevel", response.data.accountLevel, { expires: 30 });
                  })
                } else {
                  this.loading = false;
                  this.getCode();
                }
              })
              .catch(() => {
                this.loading = false;
                this.getCode();
              });
          }
        });
      },
        // 点击快速注册
        goRegister(){
          this.$router.replace({
            path: "/regist",
            query:{
              uid:this.queryuid
            }
            });
        },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .openSidebar:hover{
    cursor: pointer;
  }
  .el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #333;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
    color: #ffffff;
  }
  .body {
    width: 100%;
    height: 100vh;
    background-image: url(../assets/images/bgg.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .login_box {

    width: 28rem;
    height: 31.25rem;
    position: absolute;
    top: 0;
    left: 50rem;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 2rem;
    background: #ffffff;
    /* border-radius: 10px; */
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
  .explain{
    position: absolute;
    bottom: 20px;
    color: #0C3046;
    /* color: #fff; */
    font-weight: 600;
    font-size: 12px;
  }
  .left_box {
    width: 50%;
    height: 100%;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    /* background: rgb(255, 242, 240); */
    background-color: #75CAF2;
    border-right: #0D3147 solid 1px;
  }

  .left_box img {
    width: 60%;
    height: 60%;
    object-fit: contain;
  }

  .right_box {
    width: 100%;
    height: 100%;
    /* border-bottom-right-radius: 10px; */
    /* border-top-right-radius: 10px; */
    /* padding: 0 10%; */
    border-radius: 2rem;
    background: #ffffff;

  }
  .right_box_item{
    padding: 0 50px;
  }
  .login_con{
    margin-top: 1.25rem;
  }
  .login_con .el-input {
    height: 2.8125rem;
  }
  .login_title{
    margin-top: 4.6875rem;
  }
  .login_title p {
    font-size: 1.5rem;
    color: black;
    font-weight: bold;
  }

  .verification_box {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
  }

  .verification_con {
    width: 8.75rem;
    height: 2.375rem;
    border: 1px solid red;
    margin-bottom: 1.6875rem;
    margin-left: 0.875rem;
  }

  .login-code {
    width: 33%;
    height: 38px;
    float: right;
    margin-bottom: 22px;
  }

  .login-code img {
    cursor: pointer;
    vertical-align: middle;
  }

  .login-code-img {
    height: 38px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue